export const colorsOptions = [
  { label: "White", value: "white" },
  { label: "Black", value: "black" },
  { label: "Blue", value: "blue" },
  { label: "Green", value: "green" },
  { label: "Yellow ", value: "yellow" },
  { label: "Red", value: "red" },
  { label: "Orange", value: "orange" },
  { label: "Silver", value: "silver" },
];

export const weightOptions = [
  { label: "5g", value: "5" },
  { label: "10g", value: "10" },
  { label: "15g", value: "15" },
  { label: "20g", value: "20" },
  { label: "25g ", value: "25" },
  { label: "30g", value: "30" },
  { label: "35g", value: "35" },
  { label: "40g", value: "40" },
  { label: "45g", value: "45" },
  { label: "50g", value: "50" },
  { label: "55g", value: "55" },
  { label: "60g", value: "60" },
  { label: "65g", value: "65" },
  { label: "70g", value: "70" },
  { label: "75g", value: "75" },
  { label: "100g", value: "100" },
  { label: "105g", value: "105" },
  { label: "120g", value: "120" },
  { label: "125g", value: "125" },
  { label: "140g", value: "140" },
  { label: "150g", value: "150" },
  { label: "160g", value: "160" },
  { label: "175g", value: "175" },
  { label: "200g", value: "200" },
  { label: "250g", value: "250" },
  { label: "500g", value: "500" },
  { label: "1000g", value: "1000" },
  { label: "1500g", value: "1500" },
  { label: "2000g", value: "2000" },
  { label: "2500g", value: "2500" },
  { label: "3000g", value: "3000" },
  { label: "3500g", value: "3500" },
  { label: "4000g", value: "4000" },
  { label: "5000g", value: "5000" },
  { label: "10000g", value: "10000" },
];
